export default "__VITE_ASSET__C$$WUdOZ__"